import React, { Component } from 'react';
import { Button, Form } from 'tabler-react';
import { api_bot } from '../../config/config';
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import * as conf from '../../config/config';

class ChatBot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [
        { text: `¡Hola Usuario! ¿En qué puedo ayudarte?`, sender: 'bot', time: new Date().toLocaleTimeString() }
      ],
      inputMessage: '',
      conversations: [],
      currentConversationId: null,
      sidebarOpen: false,
      isTyping: false,
      hasPollyAudio: false,
      userName: 'Usuario',
      showConfirmModal: false,
      pendingMessage: '',
      gpsToLiberate: ''
    };
    this.messagesEndRef = React.createRef();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  componentDidMount() {
    this.loadConversations();
    this.loadUserName();
  }

  loadUserName = () => {
    let userName = this.props.userName || 'Usuario';
    
    // Intentar obtener desde sessionStorage si no viene en props
    if (userName === 'Usuario') {
      try {
        const usuarioData = sessionStorage.getItem('Usuario');
        if (usuarioData) {
          const usuario = JSON.parse(usuarioData);
          if (usuario.persona) {
            const nombre = usuario.persona.nombre || '';
            const aPaterno = usuario.persona.aPaterno || '';
            const aMaterno = usuario.persona.aMaterno || '';
            userName = `${nombre} ${aPaterno} ${aMaterno}`.trim();
          }
        }
      } catch (error) {
        console.error('Error al obtener usuario del sessionStorage:', error);
      }
    }

    // Actualizar el mensaje inicial si cambió el nombre
    if (userName !== this.state.userName) {
      this.setState(prevState => ({
        userName: userName,
        messages: [
          { text: `¡Hola ${userName}! ¿En qué puedo ayudarte?`, sender: 'bot', time: new Date().toLocaleTimeString() }
        ]
      }));
    }
  };

  scrollToBottom = () => {
    if (this.messagesEndRef.current) {
      this.messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  sendMessage = () => {
    if (this.state.inputMessage.trim()) {
      const userMessage = this.state.inputMessage;
      
      // Detectar si es una solicitud de liberación
      if (userMessage.toLowerCase().includes('libera') && (userMessage.toLowerCase().includes('gps') || /[A-Za-z]\d+/i.test(userMessage))) {
        this.checkGpsStatus(userMessage);
        return;
      }
      
      this.processSendMessage(userMessage);
    }
  };

  checkGpsStatus = async (userMessage) => {
    // Extraer el nombre del GPS del mensaje (capturar todo después de "gps")
    const gpsMatch = userMessage.match(/gps\s+([A-Za-z0-9\s\-]+)/i);
    console.log('GPS Match:', gpsMatch);
    if (!gpsMatch) {
      this.processSendMessage(userMessage);
      return;
    }
    
    const fullGpsName = gpsMatch[1].trim();
    // Para la API, usar solo la primera parte (antes del primer espacio)
    const gpsNameForApi = fullGpsName.split(' ')[0].toUpperCase();
    console.log('GPS Name completo:', fullGpsName);
    console.log('GPS Name para API:', gpsNameForApi);
    this.setState({ isTyping: true });
    
    try {
      const url = `${conf.api_raiz}gps/nombre/${gpsNameForApi}/pag/1`;
      console.log('Consultando URL:', url);
      
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('tok')}`
        }
      });
      
      console.log('Response status:', response.status);
      
      if (response.ok) {
        const gpsData = await response.json();
        console.log('GPS Data:', gpsData);
        this.setState({ isTyping: false });
        
        if (gpsData.length > 0) {
          console.log('GPS Estatus ID:', gpsData[0].gpsEstatus.id);
          if (gpsData[0].gpsEstatus.id === 2) {
            console.log('Mostrando modal de confirmación');
            // Si el estatus es 2, mostrar modal de confirmación
            this.setState({
              showConfirmModal: true,
              pendingMessage: userMessage,
              gpsToLiberate: fullGpsName
            });
          } else {
            console.log('Estatus no es 2, enviando mensaje normal');
            // Si no es estatus 2, enviar mensaje normal
            this.processSendMessage(userMessage);
          }
        } else {
          console.log('No se encontró GPS, enviando mensaje normal');
          this.processSendMessage(userMessage);
        }
      } else {
        console.log('Error en response:', response.status);
        this.setState({ isTyping: false });
        this.processSendMessage(userMessage);
      }
    } catch (error) {
      console.log('Error en fetch:', error);
      this.setState({ isTyping: false });
      this.processSendMessage(userMessage);
    }
  };

  processSendMessage = (userMessage) => {
    const newMessage = {
      text: userMessage,
      sender: 'user',
      time: new Date().toLocaleTimeString()
    };
    
    this.setState({
      messages: [...this.state.messages, newMessage],
      inputMessage: ''
    }, () => {
      this.updateCurrentConversation();
      this.setState({ isTyping: true });
      this.processMessage(userMessage);
    });
  };

  confirmLiberation = () => {
    this.setState({
      showConfirmModal: false
    });
    this.processSendMessage(this.state.pendingMessage);
  };

  cancelLiberation = () => {
    this.setState({
      showConfirmModal: false,
      pendingMessage: '',
      gpsToLiberate: ''
    });
  };

  processMessage = async (message) => {
    console.log('Enviando mensaje:', message);
    
    // Crear mensaje bot vacío para streaming
    const botResponse = {
      text: '',
      sender: 'bot',
      time: new Date().toLocaleTimeString(),
      isStreaming: true
    };

    this.setState({
      messages: [...this.state.messages, botResponse],
      isTyping: false,
      hasPollyAudio: false
    });

    try {
      const response = await fetch(`${api_bot}/api/agent/stream`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: message })
      });

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      const readStream = async () => {
        const { done, value } = await reader.read();
        if (done) {
          // Marcar como completado
          this.setState(prevState => ({
            messages: prevState.messages.map((msg, index) => 
              index === prevState.messages.length - 1 
                ? { ...msg, isStreaming: false }
                : msg
            )
          }), () => {
            this.updateCurrentConversation();
            // Log a bitacoras.catalogosLog solo si se liberó un GPS
            const botResponse = this.state.messages[this.state.messages.length - 1]?.text || "";
            if (botResponse.includes("ha sido liberado exitosamente")) {
              const user = JSON.parse(sessionStorage.getItem("usuario"));
              const logData = {
                nombreCatalogo: "PatiosBot",
                usuario: user ? user.persona : 0,
                accionFecha: null,
                metodo: "post",
                data: JSON.stringify({
                  pregunta: message,
                  respuesta: botResponse
                }),
                request: JSON.stringify({ message: message }),
                error: ""
              };
              Crud_Catalogos("catalogosLog", "", "post", "", logData);
            }
          });
          return;
        }

        const chunk = decoder.decode(value);
        const lines = chunk.split('\n');

        lines.forEach(line => {
          if (line.startsWith('data: ')) {
            try {
              const data = JSON.parse(line.slice(6));
              
              this.setState(prevState => ({
                messages: prevState.messages.map((msg, index) => {
                  if (index === prevState.messages.length - 1) {
                    if (data.type === 'start' || data.type === 'thinking') {
                      return { ...msg, text: data.message, isThinking: true };
                    } else if (data.type === 'content') {
                      const newText = msg.isThinking ? data.chunk : msg.text + ' ' + data.chunk;
                      return { ...msg, text: newText, isThinking: false };
                    }
                  }
                  return msg;
                })
              }));

              // Reproducir audio de Polly cuando llegue el evento
              if (data.type === 'audio' && data.path) {
                console.log('Reproduciendo audio de Polly');
                this.setState({ hasPollyAudio: true });
                
                const audioUrl = `${api_bot}${data.path}`;
                const audio = new Audio(audioUrl);
                this.setState({ currentAudio: audio });
                
                audio.onended = () => this.setState({ currentAudio: null });
                audio.play()
                  .then(() => console.log('Audio de Polly reproduciéndose'))
                  .catch(e => {
                    console.error('Error con Polly:', e);
                  });
              }
            } catch (e) {
              console.error('Error parsing JSON:', e);
            }
          }
        });

        return readStream();
      };

      await readStream();
      
    } catch (error) {
      console.error('Error:', error);
      this.setState(prevState => ({
        messages: prevState.messages.map((msg, index) => 
          index === prevState.messages.length - 1 
            ? { ...msg, text: `Error de conexión: ${error.message}`, isStreaming: false }
            : msg
        )
      }));
    }
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.sendMessage();
    }
  };

  loadConversations = () => {
    const saved = localStorage.getItem('chatbot_conversations');
    if (saved) {
      const conversations = JSON.parse(saved);
      this.setState({ conversations });
    }
  };

  createNewConversation = () => {
    const userName = this.props.userName || (this.props.datosForm && this.props.datosForm.userName) || 'Usuario';
    const newId = Date.now().toString();
    const newConversation = {
      id: newId,
      title: 'Nueva conversación',
      messages: [
        { text: `¡Hola ${userName}! ¿En qué puedo ayudarte?`, sender: 'bot', time: new Date().toLocaleTimeString() }
      ],
      createdAt: new Date().toISOString()
    };
    
    const updatedConversations = [newConversation, ...this.state.conversations];
    this.setState({
      conversations: updatedConversations,
      currentConversationId: newId,
      messages: newConversation.messages,
      sidebarOpen: false
    }, () => {
      localStorage.setItem('chatbot_conversations', JSON.stringify(updatedConversations));
    });
  };

  loadConversation = (conversationId) => {
    const conversation = this.state.conversations.find(c => c.id === conversationId);
    if (conversation) {
      this.setState({
        currentConversationId: conversationId,
        messages: conversation.messages,
        sidebarOpen: false
      });
    }
  };

  updateCurrentConversation = () => {
    if (this.state.currentConversationId && this.state.conversations.length > 0) {
      const updatedConversations = this.state.conversations.map(conv => {
        if (conv.id === this.state.currentConversationId) {
          const userMessage = this.state.messages.find(m => m.sender === 'user');
          return {
            ...conv,
            messages: [...this.state.messages],
            title: userMessage ? userMessage.text.substring(0, 30) + '...' : 'Nueva conversación'
          };
        }
        return conv;
      });
      
      this.setState({ conversations: updatedConversations }, () => {
        localStorage.setItem('chatbot_conversations', JSON.stringify(updatedConversations));
      });
    }
  };

  render() {
    return (
      <>
        <style>
          {`
            @keyframes pulse {
              0% { opacity: 1; transform: scale(1); }
              50% { opacity: 0.5; transform: scale(1.2); }
              100% { opacity: 1; transform: scale(1); }
            }
            @keyframes typing {
              0%, 60%, 100% { transform: translateY(0); }
              30% { transform: translateY(-10px); }
            }
            .typing-dot {
              width: 8px;
              height: 8px;
              border-radius: 50%;
              background-color: #6c757d;
              display: inline-block;
              margin: 0 2px;
              animation: typing 1.4s infinite ease-in-out;
            }
            .typing-dot:nth-child(1) { animation-delay: 0s; }
            .typing-dot:nth-child(2) { animation-delay: 0.2s; }
            .typing-dot:nth-child(3) { animation-delay: 0.4s; }
          `}
        </style>
        
        <div style={{ 
          height: '450px', 
          display: 'flex', 
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          border: '1px solid #e1e5e9',
          backgroundColor: 'white'
        }}>
          
          <div style={{
            width: this.state.sidebarOpen ? '260px' : '0',
            backgroundColor: '#f8f9fa',
            borderRight: this.state.sidebarOpen ? '1px solid #e1e5e9' : 'none',
            transition: 'width 0.3s ease',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <div style={{ 
              padding: '16px', 
              borderBottom: '1px solid #e1e5e9', 
              backgroundColor: '#007bff', 
              color: 'white'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '14px', fontWeight: '500' }}>Conversaciones</span>
                <button
                  onClick={this.createNewConversation}
                  style={{
                    background: 'rgba(255,255,255,0.2)',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '6px 8px',
                    color: 'white',
                    cursor: 'pointer'
                  }}
                >
                  <i className="fa fa-plus" />
                </button>
              </div>
            </div>
            
            <div style={{ flex: 1, overflowY: 'auto', padding: '12px' }}>
              {this.state.conversations.length > 0 ? this.state.conversations.map(conv => (
                <div
                  key={conv.id}
                  onClick={() => this.loadConversation(conv.id)}
                  style={{
                    padding: '12px',
                    marginBottom: '8px',
                    backgroundColor: conv.id === this.state.currentConversationId ? '#007bff' : 'white',
                    color: conv.id === this.state.currentConversationId ? 'white' : '#495057',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    border: '1px solid #e1e5e9'
                  }}
                >
                  <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '4px' }}>
                    {(conv.title || 'Nueva conversación').substring(0, 28)}...
                  </div>
                  <div style={{ fontSize: '11px', opacity: 0.7 }}>
                    {new Date(conv.createdAt).toLocaleDateString()}
                  </div>
                </div>
              )) : (
                <div style={{ textAlign: 'center', color: '#6c757d', marginTop: '40px' }}>
                  <i className="fa fa-comments" style={{ fontSize: '32px', marginBottom: '12px', opacity: 0.4 }} />
                  <div style={{ fontSize: '13px' }}>Sin conversaciones</div>
                </div>
              )}
            </div>
          </div>

          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
           

            <div style={{ 
              flex: 1, 
              overflowY: 'auto', 
              padding: '16px', 
              backgroundColor: '#f8f9fa'
            }}>
              {this.state.messages.map((msg, index) => (
                <div key={index} style={{
                  marginBottom: '16px',
                  display: 'flex',
                  justifyContent: msg.sender === 'user' ? 'flex-end' : 'flex-start'
                }}>
                  <div style={{
                    maxWidth: '70%',
                    padding: '12px 16px',
                    borderRadius: msg.sender === 'user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                    backgroundColor: msg.sender === 'user' ? '#007bff' : 'white',
                    color: msg.sender === 'user' ? 'white' : '#495057',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: msg.sender === 'bot' ? '1px solid #e1e5e9' : 'none'
                  }}>
                    <div style={{ fontSize: '14px', lineHeight: '1.4' }}>
                      {msg.isThinking ? <em>{msg.text}</em> : msg.text}
                    </div>
                    <div style={{ 
                      fontSize: '11px', 
                      opacity: 0.7, 
                      marginTop: '6px',
                      textAlign: 'right'
                    }}>
                      {msg.time}
                    </div>
                  </div>
                </div>
              ))}
              
              {this.state.isTyping && (
                <div style={{
                  marginBottom: '16px',
                  display: 'flex',
                  justifyContent: 'flex-start'
                }}>
                  <div style={{
                    padding: '12px 16px',
                    borderRadius: '18px 18px 18px 4px',
                    backgroundColor: 'white',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '1px solid #e1e5e9',
                    minWidth: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <div className="typing-dot"></div>
                    <div className="typing-dot"></div>
                    <div className="typing-dot"></div>
                  </div>
                </div>
              )}
              <div ref={this.messagesEndRef} />
            </div>
            
            <div style={{ 
              padding: '16px', 
              display: 'flex', 
              gap: '12px',
              backgroundColor: 'white',
              borderTop: '1px solid #e1e5e9'
            }}>
              <Form.Input
                value={this.state.inputMessage}
                onChange={(e) => this.setState({ inputMessage: e.target.value })}
                onKeyPress={this.handleKeyPress}
                placeholder="Escribe tu mensaje..."
                style={{ 
                  flex: 1,
                  borderRadius: '20px',
                  border: '1px solid #e1e5e9',
                  padding: '10px 16px',
                  fontSize: '14px'
                }}
              />
              <button
                onClick={this.sendMessage}
                disabled={!this.state.inputMessage.trim()}
                style={{
                  background: this.state.inputMessage.trim() ? '#007bff' : '#6c757d',
                  border: 'none',
                  borderRadius: '50%',
                  width: '44px',
                  height: '44px',
                  color: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="fa fa-paper-plane" />
              </button>
            </div>
          </div>
        </div>

        {/* Modal de confirmación */}
        {this.state.showConfirmModal && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}>
            <div style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              padding: '24px',
              maxWidth: '400px',
              width: '90%',
              boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
            }}>
              <h4 style={{ marginBottom: '16px', color: '#495057' }}>
                Confirmar Liberación
              </h4>
              <p style={{ marginBottom: '20px', color: '#6c757d' }}>
                ¿Estás seguro de que deseas liberar el dispositivo GPS <strong>{this.state.gpsToLiberate}</strong>?
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                <button
                  onClick={this.cancelLiberation}
                  style={{
                    padding: '8px 16px',
                    border: '1px solid #6c757d',
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    color: '#6c757d',
                    cursor: 'pointer'
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={this.confirmLiberation}
                  style={{
                    padding: '8px 16px',
                    border: 'none',
                    borderRadius: '4px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    cursor: 'pointer'
                  }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default ChatBot;
